<div class="content__wrapper">
  <p-toast key="main"></p-toast>
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra ASC"
      (logout)="onLogout()"
      [menuItems]="menuItems"
    />
  }
  <router-outlet></router-outlet>
</div>
